import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LandingPage } from 'src/app/models/firebase/landing-page';

@Component({
  selector: 'app-our-working-process',
  templateUrl: './our-working-process.component.html',
  styleUrls: ['./our-working-process.component.scss']
})
export class OurWorkingProcessComponent {
    @Input() ourWorkingProcessData: LandingPage = null;
    constructor(
        private router: Router
    ){

    }
    navigate(){
        this.router.navigate(['/about-us'])
    }
}
